import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Motion";
import { CATERING, CONTACT } from "@/data/content";

const Catering = () => (
  <section id="catering" className="py-28 sm:py-36 overflow-hidden" data-testid="catering-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12 grid lg:grid-cols-12 gap-16 lg:gap-10 items-center">
      <div className="lg:col-span-6 relative">
        <Reveal y={60}>
          <div className="group relative overflow-hidden rounded-[2rem] w-[82%]">
            <img
              src={CATERING.img1}
              alt="Copper handis lined up at a Forco Amore catered event"
              loading="lazy"
              className="img-lux w-full aspect-[4/5] object-cover"
              data-testid="catering-image-1"
            />
          </div>
        </Reveal>
        <Reveal delay={0.2} y={60} className="absolute -bottom-10 right-0 w-[52%]">
          <div className="group relative overflow-hidden rounded-[2rem] border-8 border-cream shadow-[0_30px_60px_-20px_rgba(26,23,19,0.35)]">
            <img
              src={CATERING.img2}
              alt="A lavish buffet line at a catered celebration"
              loading="lazy"
              className="img-lux w-full aspect-[4/3] object-cover"
              data-testid="catering-image-2"
            />
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6 lg:pl-16 pt-10 lg:pt-0">
        <Reveal>
          <Overline className="text-wine">{CATERING.overline}</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight mt-5">
            We Bring the <span className="italic text-wine">Feast</span> to You
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-faded text-base md:text-lg font-light leading-relaxed max-w-xl">
            {CATERING.text}
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <ul className="mt-8 space-y-4">
            {CATERING.points.map((p, i) => (
              <li key={p} className="flex items-center gap-4" data-testid={`catering-point-${i}`}>
                <span className="h-2 w-2 rounded-full bg-brass shrink-0" />
                <span className="text-ink/85 text-base font-light">{p}</span>
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-10 flex flex-wrap items-center gap-5">
            <Link
              to="/contact"
              data-testid="catering-cta-btn"
              className="rounded-full bg-wine px-9 py-4 text-sm tracking-[0.14em] uppercase text-cream hover:bg-winedark hover:scale-[1.03] active:scale-95 transition-all duration-300"
            >
              Plan Your Event
            </Link>
            <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="catering-phone-link" className="text-sm tracking-wider text-faded hover:text-wine transition-colors">
              or call {CONTACT.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Catering;
